import { Helmet } from "react-helmet";
import { useT } from "../hooks/useLang";


export default function QuiSommesNous() {
  const t = useT();


  return (
    <div className="min-h-screen pb-16" style={{ background: "var(--bg)", paddingTop: "10px" }}>
      <Helmet>
        <title>Starting Five - Accueil</title>
        <meta name="description" content="Starting Five, groupe togolais proposant des services innovants pour simplifier votre quotidien." />
      </Helmet>
      <div className="zigzag-band" />

      <div className="max-w-3xl mx-auto px-6 pt-16">

        <span className="eyebrow">{t("notreHistoire")}</span>
        <h1 className="page-title" style={{
          fontFamily: "var(--font-display)",
          fontSize: "clamp(2rem, 5vw, 3rem)",
          lineHeight: 1.05,
          marginBottom: "2.5rem",
        }}>
          {t("quiTitre")}
        </h1>

        <div className="brut-card p-8 mb-8">
          <p className="text-lg font-bold mb-4" style={{ color: "var(--ink)" }}>
            {t("quiIntro")}
          </p>
          <p style={{ color: "var(--ink-soft)", fontWeight: 500, lineHeight: 1.7 }}>
            {t("quiTexte1")}
            <br /><br />
            {t("quiTexte2")}
            <br /><br />
            {t("quiTexte3")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { icon: "🎯", title: t("mission"), text: t("missionText"), bg: "var(--red)" },
            { icon: "🌍", title: t("vision"),  text: t("visionText"),  bg: "var(--green)" },
            { icon: "❤️", title: t("valeurs"), text: t("valeursText"), bg: "var(--accent)" },
          ].map((v) => (
            <div key={v.title} className="brut-card p-6 hover:-translate-x-0.5 hover:-translate-y-0.5 transition-transform">
              <div style={{
                width: 52, height: 52,
                border: "3px solid var(--border)", borderRadius: 10,
                background: v.bg,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "1.5rem", marginBottom: 14,
                boxShadow: "var(--shadow-sm)",
              }}>
                {v.icon}
              </div>
              <h3 className="font-bold text-lg mb-2" style={{ color: "var(--ink)" }}>{v.title}</h3>
              <p style={{ color: "var(--ink-soft)", fontWeight: 500 }}>{v.text}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}